export default [
    {
        title: "Monday",
        key: "mon"
    },
    {
        title: "Tuesday",
        key: "tue"
    },
    {
        title: "Wednesday",
        key: "wed"
    },
    {
        title: "Thursday",
        key: "thur"
    },
    {
        title: "Friday",
        key: "fri"
    },
    {
        title: "Saturday",
        key: "sat"
    },
    {
        title: "Sunday",
        key: "sun"
    }
];
